import { useMemo, useState } from 'react';
import { Brand } from '~/lib/data-contract/auto-generated/shop-api-model';
import useBrand from '~/services/shop/hooks/useBrandSearch';
import useCategories from '~/services/shop/hooks/useCategories';

export default function useBrandFiltering() {
    const [query, setQuery] = useState<string>('');
    const [category, setCategory] = useState<string>('');
    const { data: categories, isLoading: isLoadingCategories } = useCategories();
    const { data: brands, isLoading: isLoadingBrands, isError } = useBrand(category, query);
    const allLetters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÆØÅ'.split('');

    const existingLettersByBrand = useMemo(() => {
        if (!brands?.brands) {
            return [];
        }
        const arr: { [key: string]: Brand[] } = {};

        brands?.brands?.forEach((brand) => {
            const firstLetter = brand.name?.slice(0, 1).toUpperCase();
            if (firstLetter) {
                if (!arr[firstLetter]) {
                    arr[firstLetter] = [];
                }
                arr[firstLetter].push(brand);
            }
        });

        return Object.entries(arr);
    }, [brands?.brands]);

    return {
        isError,
        isLoadingCategories,
        isLoadingBrands,
        query,
        setQuery,
        category,
        setCategory,
        categories,
        brands,
        allLetters,
        existingLettersByBrand,
    };
}
